import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@tq/ui-components';
import { EmptyDataCard } from 'components';
import { ConsultationResponseProps } from '../../types';
import { RpcResponseAnswers } from '..';
import { useResponse } from '../../hooks';

export const RpcPastResponses: React.FC<ConsultationResponseProps> = ({ consultation }) => {
  const { t } = useTranslation('consultation_response');

  const { pastAnswers } = useResponse(consultation.id);

  return (
    <Box pt={{ base: 3, lg: 6 }}>
      <Box pb={6} p={{ base: 3, lg: 4 }}>
        <h3>
          <strong>{t('answered_questions', 'Answered questions')}</strong>
        </h3>
      </Box>
      {!pastAnswers?.length ? (
        <Box px={{ base: 0, lg: 2 }}>
          <EmptyDataCard message={t('no_responses_message', 'No responses available')} />
        </Box>
      ) : (
        <Box px={{ base: 3, lg: 4 }} pb={6}>
          <RpcResponseAnswers answers={pastAnswers} showEdit={false} />
        </Box>
      )}
    </Box>
  );
};
